import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ICalendarConfigurationFieldsFragment = {
  calendarSharing?: boolean | null
  calendarDeliverySharingMode?: Types.SharingMode | null
  calendarFormSharingMode?: Types.SharingMode | null
  restrictByInvites?: boolean | null
  deliverySharingFrom?: any | null
  deliverySharingTo?: any | null
  formSharingFrom?: any | null
  formSharingTo?: any | null
}

export type IGetCalendarConfigurationQueryVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input']
}>

export type IGetCalendarConfigurationQuery = {
  getCalendarConfiguration?: {
    calendarSharing?: boolean | null
    calendarDeliverySharingMode?: Types.SharingMode | null
    calendarFormSharingMode?: Types.SharingMode | null
    restrictByInvites?: boolean | null
    deliverySharingFrom?: any | null
    deliverySharingTo?: any | null
    formSharingFrom?: any | null
    formSharingTo?: any | null
  } | null
}

export type IUpdateProjectFormDateRangeMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  formFrom: Types.Scalars['DateTime']['input']
  formTo: Types.Scalars['DateTime']['input']
}>

export type IUpdateProjectFormDateRangeMutation = {
  updateProjectFormDateRange?: {
    calendarSharing?: boolean | null
    calendarDeliverySharingMode?: Types.SharingMode | null
    calendarFormSharingMode?: Types.SharingMode | null
    restrictByInvites?: boolean | null
    deliverySharingFrom?: any | null
    deliverySharingTo?: any | null
    formSharingFrom?: any | null
    formSharingTo?: any | null
  } | null
}

export type IUpdateProjectDeliveryDateRangeMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  deliveryFrom: Types.Scalars['DateTime']['input']
  deliveryTo: Types.Scalars['DateTime']['input']
}>

export type IUpdateProjectDeliveryDateRangeMutation = {
  updateProjectDeliveryDateRange?: {
    calendarSharing?: boolean | null
    calendarDeliverySharingMode?: Types.SharingMode | null
    calendarFormSharingMode?: Types.SharingMode | null
    restrictByInvites?: boolean | null
    deliverySharingFrom?: any | null
    deliverySharingTo?: any | null
    formSharingFrom?: any | null
    formSharingTo?: any | null
  } | null
}

export type IUpdateProjectCalendarSharingMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  calendarSharing: Types.Scalars['Boolean']['input']
}>

export type IUpdateProjectCalendarSharingMutation = {
  updateProjectCalendarSharing?: {
    calendarSharing?: boolean | null
    calendarDeliverySharingMode?: Types.SharingMode | null
    calendarFormSharingMode?: Types.SharingMode | null
    restrictByInvites?: boolean | null
    deliverySharingFrom?: any | null
    deliverySharingTo?: any | null
    formSharingFrom?: any | null
    formSharingTo?: any | null
  } | null
}

export type IUpdateProjectRestrictByInviteCodesMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  restrictByInviting: Types.Scalars['Boolean']['input']
}>

export type IUpdateProjectRestrictByInviteCodesMutation = {
  updateProjectRestrictByInvitation?: {
    calendarSharing?: boolean | null
    calendarDeliverySharingMode?: Types.SharingMode | null
    calendarFormSharingMode?: Types.SharingMode | null
    restrictByInvites?: boolean | null
    deliverySharingFrom?: any | null
    deliverySharingTo?: any | null
    formSharingFrom?: any | null
    formSharingTo?: any | null
  } | null
}

export type IUpdateCalendarFormSharingModeMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  sharingMode: Types.SharingMode
}>

export type IUpdateCalendarFormSharingModeMutation = {
  updateCalendarFormSharingMode?: {
    calendarSharing?: boolean | null
    calendarDeliverySharingMode?: Types.SharingMode | null
    calendarFormSharingMode?: Types.SharingMode | null
    restrictByInvites?: boolean | null
    deliverySharingFrom?: any | null
    deliverySharingTo?: any | null
    formSharingFrom?: any | null
    formSharingTo?: any | null
  } | null
}

export type IUpdateCalendarDeliverySharingModeMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  sharingMode: Types.SharingMode
}>

export type IUpdateCalendarDeliverySharingModeMutation = {
  updateCalendarDeliverySharingMode?: {
    calendarSharing?: boolean | null
    calendarDeliverySharingMode?: Types.SharingMode | null
    calendarFormSharingMode?: Types.SharingMode | null
    restrictByInvites?: boolean | null
    deliverySharingFrom?: any | null
    deliverySharingTo?: any | null
    formSharingFrom?: any | null
    formSharingTo?: any | null
  } | null
}

export type IUpdateProjectRestrictByInvitationMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  restrictByInviting: Types.Scalars['Boolean']['input']
}>

export type IUpdateProjectRestrictByInvitationMutation = {
  updateProjectRestrictByInvitation?: {
    calendarSharing?: boolean | null
    calendarDeliverySharingMode?: Types.SharingMode | null
    calendarFormSharingMode?: Types.SharingMode | null
    restrictByInvites?: boolean | null
    deliverySharingFrom?: any | null
    deliverySharingTo?: any | null
    formSharingFrom?: any | null
    formSharingTo?: any | null
  } | null
}

export const CalendarConfigurationFieldsFragmentDoc = gql`
  fragment CalendarConfigurationFields on CalendarConfiguration {
    calendarSharing
    calendarDeliverySharingMode
    calendarFormSharingMode
    restrictByInvites
    deliverySharingFrom
    deliverySharingTo
    formSharingFrom
    formSharingTo
  }
`
export const GetCalendarConfigurationDocument = gql`
  query GetCalendarConfiguration($projectId: String!) {
    getCalendarConfiguration(projectId: $projectId) {
      ...CalendarConfigurationFields
    }
  }
  ${CalendarConfigurationFieldsFragmentDoc}
`

/**
 * __useGetCalendarConfigurationQuery__
 *
 * To run a query within a React component, call `useGetCalendarConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarConfigurationQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetCalendarConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetCalendarConfigurationQuery,
    IGetCalendarConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetCalendarConfigurationQuery,
    IGetCalendarConfigurationQueryVariables
  >(GetCalendarConfigurationDocument, options)
}
export function useGetCalendarConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetCalendarConfigurationQuery,
    IGetCalendarConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetCalendarConfigurationQuery,
    IGetCalendarConfigurationQueryVariables
  >(GetCalendarConfigurationDocument, options)
}
export type GetCalendarConfigurationQueryHookResult = ReturnType<
  typeof useGetCalendarConfigurationQuery
>
export type GetCalendarConfigurationLazyQueryHookResult = ReturnType<
  typeof useGetCalendarConfigurationLazyQuery
>
export type GetCalendarConfigurationQueryResult = Apollo.QueryResult<
  IGetCalendarConfigurationQuery,
  IGetCalendarConfigurationQueryVariables
>
export const UpdateProjectFormDateRangeDocument = gql`
  mutation UpdateProjectFormDateRange(
    $projectId: ObjectId!
    $formFrom: DateTime!
    $formTo: DateTime!
  ) {
    updateProjectFormDateRange(
      projectId: $projectId
      formFrom: $formFrom
      formTo: $formTo
    ) {
      ...CalendarConfigurationFields
    }
  }
  ${CalendarConfigurationFieldsFragmentDoc}
`
export type IUpdateProjectFormDateRangeMutationFn = Apollo.MutationFunction<
  IUpdateProjectFormDateRangeMutation,
  IUpdateProjectFormDateRangeMutationVariables
>

/**
 * __useUpdateProjectFormDateRangeMutation__
 *
 * To run a mutation, you first call `useUpdateProjectFormDateRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectFormDateRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectFormDateRangeMutation, { data, loading, error }] = useUpdateProjectFormDateRangeMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      formFrom: // value for 'formFrom'
 *      formTo: // value for 'formTo'
 *   },
 * });
 */
export function useUpdateProjectFormDateRangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateProjectFormDateRangeMutation,
    IUpdateProjectFormDateRangeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateProjectFormDateRangeMutation,
    IUpdateProjectFormDateRangeMutationVariables
  >(UpdateProjectFormDateRangeDocument, options)
}
export type UpdateProjectFormDateRangeMutationHookResult = ReturnType<
  typeof useUpdateProjectFormDateRangeMutation
>
export type UpdateProjectFormDateRangeMutationResult =
  Apollo.MutationResult<IUpdateProjectFormDateRangeMutation>
export type UpdateProjectFormDateRangeMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateProjectFormDateRangeMutation,
    IUpdateProjectFormDateRangeMutationVariables
  >
export const UpdateProjectDeliveryDateRangeDocument = gql`
  mutation UpdateProjectDeliveryDateRange(
    $projectId: ObjectId!
    $deliveryFrom: DateTime!
    $deliveryTo: DateTime!
  ) {
    updateProjectDeliveryDateRange(
      projectId: $projectId
      deliveryFrom: $deliveryFrom
      deliveryTo: $deliveryTo
    ) {
      ...CalendarConfigurationFields
    }
  }
  ${CalendarConfigurationFieldsFragmentDoc}
`
export type IUpdateProjectDeliveryDateRangeMutationFn = Apollo.MutationFunction<
  IUpdateProjectDeliveryDateRangeMutation,
  IUpdateProjectDeliveryDateRangeMutationVariables
>

/**
 * __useUpdateProjectDeliveryDateRangeMutation__
 *
 * To run a mutation, you first call `useUpdateProjectDeliveryDateRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectDeliveryDateRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectDeliveryDateRangeMutation, { data, loading, error }] = useUpdateProjectDeliveryDateRangeMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      deliveryFrom: // value for 'deliveryFrom'
 *      deliveryTo: // value for 'deliveryTo'
 *   },
 * });
 */
export function useUpdateProjectDeliveryDateRangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateProjectDeliveryDateRangeMutation,
    IUpdateProjectDeliveryDateRangeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateProjectDeliveryDateRangeMutation,
    IUpdateProjectDeliveryDateRangeMutationVariables
  >(UpdateProjectDeliveryDateRangeDocument, options)
}
export type UpdateProjectDeliveryDateRangeMutationHookResult = ReturnType<
  typeof useUpdateProjectDeliveryDateRangeMutation
>
export type UpdateProjectDeliveryDateRangeMutationResult =
  Apollo.MutationResult<IUpdateProjectDeliveryDateRangeMutation>
export type UpdateProjectDeliveryDateRangeMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateProjectDeliveryDateRangeMutation,
    IUpdateProjectDeliveryDateRangeMutationVariables
  >
export const UpdateProjectCalendarSharingDocument = gql`
  mutation UpdateProjectCalendarSharing(
    $projectId: ObjectId!
    $calendarSharing: Boolean!
  ) {
    updateProjectCalendarSharing(
      projectId: $projectId
      calendarSharing: $calendarSharing
    ) {
      ...CalendarConfigurationFields
    }
  }
  ${CalendarConfigurationFieldsFragmentDoc}
`
export type IUpdateProjectCalendarSharingMutationFn = Apollo.MutationFunction<
  IUpdateProjectCalendarSharingMutation,
  IUpdateProjectCalendarSharingMutationVariables
>

/**
 * __useUpdateProjectCalendarSharingMutation__
 *
 * To run a mutation, you first call `useUpdateProjectCalendarSharingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectCalendarSharingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectCalendarSharingMutation, { data, loading, error }] = useUpdateProjectCalendarSharingMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      calendarSharing: // value for 'calendarSharing'
 *   },
 * });
 */
export function useUpdateProjectCalendarSharingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateProjectCalendarSharingMutation,
    IUpdateProjectCalendarSharingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateProjectCalendarSharingMutation,
    IUpdateProjectCalendarSharingMutationVariables
  >(UpdateProjectCalendarSharingDocument, options)
}
export type UpdateProjectCalendarSharingMutationHookResult = ReturnType<
  typeof useUpdateProjectCalendarSharingMutation
>
export type UpdateProjectCalendarSharingMutationResult =
  Apollo.MutationResult<IUpdateProjectCalendarSharingMutation>
export type UpdateProjectCalendarSharingMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateProjectCalendarSharingMutation,
    IUpdateProjectCalendarSharingMutationVariables
  >
export const UpdateProjectRestrictByInviteCodesDocument = gql`
  mutation UpdateProjectRestrictByInviteCodes(
    $projectId: ObjectId!
    $restrictByInviting: Boolean!
  ) {
    updateProjectRestrictByInvitation(
      projectId: $projectId
      restrictByInviting: $restrictByInviting
    ) {
      ...CalendarConfigurationFields
    }
  }
  ${CalendarConfigurationFieldsFragmentDoc}
`
export type IUpdateProjectRestrictByInviteCodesMutationFn =
  Apollo.MutationFunction<
    IUpdateProjectRestrictByInviteCodesMutation,
    IUpdateProjectRestrictByInviteCodesMutationVariables
  >

/**
 * __useUpdateProjectRestrictByInviteCodesMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRestrictByInviteCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRestrictByInviteCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectRestrictByInviteCodesMutation, { data, loading, error }] = useUpdateProjectRestrictByInviteCodesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      restrictByInviting: // value for 'restrictByInviting'
 *   },
 * });
 */
export function useUpdateProjectRestrictByInviteCodesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateProjectRestrictByInviteCodesMutation,
    IUpdateProjectRestrictByInviteCodesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateProjectRestrictByInviteCodesMutation,
    IUpdateProjectRestrictByInviteCodesMutationVariables
  >(UpdateProjectRestrictByInviteCodesDocument, options)
}
export type UpdateProjectRestrictByInviteCodesMutationHookResult = ReturnType<
  typeof useUpdateProjectRestrictByInviteCodesMutation
>
export type UpdateProjectRestrictByInviteCodesMutationResult =
  Apollo.MutationResult<IUpdateProjectRestrictByInviteCodesMutation>
export type UpdateProjectRestrictByInviteCodesMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateProjectRestrictByInviteCodesMutation,
    IUpdateProjectRestrictByInviteCodesMutationVariables
  >
export const UpdateCalendarFormSharingModeDocument = gql`
  mutation updateCalendarFormSharingMode(
    $projectId: ObjectId!
    $sharingMode: SharingMode!
  ) {
    updateCalendarFormSharingMode(
      projectId: $projectId
      sharingMode: $sharingMode
    ) {
      ...CalendarConfigurationFields
    }
  }
  ${CalendarConfigurationFieldsFragmentDoc}
`
export type IUpdateCalendarFormSharingModeMutationFn = Apollo.MutationFunction<
  IUpdateCalendarFormSharingModeMutation,
  IUpdateCalendarFormSharingModeMutationVariables
>

/**
 * __useUpdateCalendarFormSharingModeMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarFormSharingModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarFormSharingModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarFormSharingModeMutation, { data, loading, error }] = useUpdateCalendarFormSharingModeMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sharingMode: // value for 'sharingMode'
 *   },
 * });
 */
export function useUpdateCalendarFormSharingModeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateCalendarFormSharingModeMutation,
    IUpdateCalendarFormSharingModeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateCalendarFormSharingModeMutation,
    IUpdateCalendarFormSharingModeMutationVariables
  >(UpdateCalendarFormSharingModeDocument, options)
}
export type UpdateCalendarFormSharingModeMutationHookResult = ReturnType<
  typeof useUpdateCalendarFormSharingModeMutation
>
export type UpdateCalendarFormSharingModeMutationResult =
  Apollo.MutationResult<IUpdateCalendarFormSharingModeMutation>
export type UpdateCalendarFormSharingModeMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateCalendarFormSharingModeMutation,
    IUpdateCalendarFormSharingModeMutationVariables
  >
export const UpdateCalendarDeliverySharingModeDocument = gql`
  mutation updateCalendarDeliverySharingMode(
    $projectId: ObjectId!
    $sharingMode: SharingMode!
  ) {
    updateCalendarDeliverySharingMode(
      projectId: $projectId
      sharingMode: $sharingMode
    ) {
      ...CalendarConfigurationFields
    }
  }
  ${CalendarConfigurationFieldsFragmentDoc}
`
export type IUpdateCalendarDeliverySharingModeMutationFn =
  Apollo.MutationFunction<
    IUpdateCalendarDeliverySharingModeMutation,
    IUpdateCalendarDeliverySharingModeMutationVariables
  >

/**
 * __useUpdateCalendarDeliverySharingModeMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarDeliverySharingModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarDeliverySharingModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarDeliverySharingModeMutation, { data, loading, error }] = useUpdateCalendarDeliverySharingModeMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sharingMode: // value for 'sharingMode'
 *   },
 * });
 */
export function useUpdateCalendarDeliverySharingModeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateCalendarDeliverySharingModeMutation,
    IUpdateCalendarDeliverySharingModeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateCalendarDeliverySharingModeMutation,
    IUpdateCalendarDeliverySharingModeMutationVariables
  >(UpdateCalendarDeliverySharingModeDocument, options)
}
export type UpdateCalendarDeliverySharingModeMutationHookResult = ReturnType<
  typeof useUpdateCalendarDeliverySharingModeMutation
>
export type UpdateCalendarDeliverySharingModeMutationResult =
  Apollo.MutationResult<IUpdateCalendarDeliverySharingModeMutation>
export type UpdateCalendarDeliverySharingModeMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateCalendarDeliverySharingModeMutation,
    IUpdateCalendarDeliverySharingModeMutationVariables
  >
export const UpdateProjectRestrictByInvitationDocument = gql`
  mutation UpdateProjectRestrictByInvitation(
    $projectId: ObjectId!
    $restrictByInviting: Boolean!
  ) {
    updateProjectRestrictByInvitation(
      projectId: $projectId
      restrictByInviting: $restrictByInviting
    ) {
      ...CalendarConfigurationFields
    }
  }
  ${CalendarConfigurationFieldsFragmentDoc}
`
export type IUpdateProjectRestrictByInvitationMutationFn =
  Apollo.MutationFunction<
    IUpdateProjectRestrictByInvitationMutation,
    IUpdateProjectRestrictByInvitationMutationVariables
  >

/**
 * __useUpdateProjectRestrictByInvitationMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRestrictByInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRestrictByInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectRestrictByInvitationMutation, { data, loading, error }] = useUpdateProjectRestrictByInvitationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      restrictByInviting: // value for 'restrictByInviting'
 *   },
 * });
 */
export function useUpdateProjectRestrictByInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateProjectRestrictByInvitationMutation,
    IUpdateProjectRestrictByInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateProjectRestrictByInvitationMutation,
    IUpdateProjectRestrictByInvitationMutationVariables
  >(UpdateProjectRestrictByInvitationDocument, options)
}
export type UpdateProjectRestrictByInvitationMutationHookResult = ReturnType<
  typeof useUpdateProjectRestrictByInvitationMutation
>
export type UpdateProjectRestrictByInvitationMutationResult =
  Apollo.MutationResult<IUpdateProjectRestrictByInvitationMutation>
export type UpdateProjectRestrictByInvitationMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateProjectRestrictByInvitationMutation,
    IUpdateProjectRestrictByInvitationMutationVariables
  >
